import type { Record } from 'pkg/api/models/record';

export enum TransactionType {
	TransactionTypeInvalid = 'invalid',
	TransactionTypePayment = 'Payment',
	TransactionTypeRefund = 'Refund',
	TransactionTypeChargeback = 'Chargeback',
	TransactionTypeFee = 'Fee',
	TransactionTypeSecondChargeback = 'SecondChargeback',
	TransactionTypeChargebackReversed = 'ChargebackReversed',
	TransactionTypePayout = 'Payout',
	TransactionTypeTransfer = 'Transfer',
	TransactionTypeTopup = 'Topup',
	TransactionTypeInternalTransfer = 'InternalTransfer',
}

export interface BalanceEvent extends Record {
	organizationId: number;
	paymentProviderId: number;
	bookingDate: number;
	type: TransactionType;
	invoiceNumber: string;
	grossAmount: number;
	netAmount: number;
	fee: number;
	currency: string;
	paymentMethod: any;
	orderId: number;
	refundId: number;
}

// BalanceReportEvent is a balance event as the balance report returns it.
export interface BalanceReportEvent extends BalanceEvent {
	// partOfInvoiceTotal is the order's total, set only on a payment that covered part of it.
	partOfInvoiceTotal?: number;
}

export interface AccountBalanceResponse {
	totalBalance: number;
	availableBalance: number;
	pendingBalance: number;
	reservedBalance: number;
	currency: string;
}
